import Button from '@components/Button';
import { useTranslation } from '@hooks';
import { useOpenUpgradeDrawer } from '@hooks/useOpenUpgradeDrawer';
import { BILLING_TYPE_MAP } from '@constants/billing';
import { UpgradeIcon } from 'assets/images/icons';

const UpgradePlanButton = ({
    className,
    defaultPlan = BILLING_TYPE_MAP.PROFESSIONAL,
    style,
    label,
    variant = 'contained',
}) => {
    const { t } = useTranslation();
    const openUpgradeDrawer = useOpenUpgradeDrawer();

    const onClickUpgradeItem = () => openUpgradeDrawer({ defaultPlan });

    return (
        <Button
            variant={variant}
            className={className}
            onClick={onClickUpgradeItem}
            sx={{
                '& svg': { height: '20px !important', width: '20px !important', marginRight: '8px' },
                '& svg path': {
                    fill: variant === 'contained' ? 'var(--light-main)' : 'var(--primary-main)',
                    fillOpacity: 1,
                },
            }}
            style={style}
        >
            <UpgradeIcon />
            {label || t('buttons.upgradePlan')}
        </Button>
    );
};

export default UpgradePlanButton;
